import { useAuth } from "../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";

export default function Topbar({ title }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ admin route detection (unchanged)
  const isAdminRoute = location.pathname.startsWith("/admin");

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  // ✅ ADD: go to profile
  const goToProfile = () => {
    navigate("/profile");
  };

  return (
    <div
      className="h-16 bg-gray-900 border-b border-gray-800
      flex items-center justify-between px-6 text-white font-semibold text-lg"
    >
      {/* LEFT : TITLE */}
      <div>{title}</div>

      {/* RIGHT : USER / ADMIN INFO */}
      {(user || isAdminRoute) && (
        <div className="flex items-center gap-4 text-sm font-normal">
          
          {/* ✅ ADD: CLICKABLE PROFILE NAME */}
          <button
            onClick={goToProfile}
            className="text-gray-300 hover:text-white
            transition flex items-center gap-2"
          >
            👤 {user?.name || user?.email || "Admin"}
          </button>

          {/* LOGOUT (UNCHANGED) */}
          <button
            onClick={handleLogout}
            className="px-3 py-1.5 bg-red-600 hover:bg-red-700
            rounded-lg text-white text-xs font-semibold transition"
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
}
